import React from 'react';

const RateInventoryCalender = ({ dateList, selectAllInventoryOfDateHandler, others }) => {
  const calendarRender = Object.keys(dateList).map(date => (
    <React.Fragment key={date}>
      <div
        className="tabcel align_middle pad_top_bot5 border_b_1 border_r_1 border_t_1 border_color_1 posrel rv_width_2 rv_height_1"
        key={`key-${date}`}
      >
        <div
          className="ovr"
          onClick={event => selectAllInventoryOfDateHandler(event, { date })}
        >
          <div className="ovr tc fnt13">{dateList[date]['monthName']}</div>
          <div className="ovr tc bld fnt16"> {dateList[date]['day']} </div>
          <div className="ovr tc txtcolr7">{dateList[date]['dayName']}</div>
          {others?.calendarSelectedDate?.[date] === date ? (
            <i className="fa fa-check color7 fnt10 color2_8 chkshow marg_right5"></i>
          ) : (
            ''
          )}
        </div>
      </div>
    </React.Fragment>
  ));

  return (
    <React.Fragment>
      <div className="inventry_wrap border_r_1 border_color_1  bg1 p_lr_15">
        <div className="inventry_inner">
          <div className="cover">
            <div className="table_seperate table_fixed bg1">
              <div className="table_row">
                <div className="tabcel align_middle pad_top_bot5 border_all_1 border_color_1 posrel bg1 rvfixed_cell rv_width_1 rv_height_1">
                  &nbsp;
                </div>
                {calendarRender}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default RateInventoryCalender;
